global.api_url = 'https://betaapi.anytrakk.com'
global.odometer_image_url = 'http://43.205.171.148:8011/storage/'
global.documents_image_url='https://betadocumentsstorage.trackyo.in/storage/'
global.company_documents_image_url = 'http://43.205.171.148:8004/storage/'
global.pincode_url = 'https://betapostalcodes.anyshipp.com'
global.privacy_policy_url = 'https://betaapi.anytrakk.com/docs/Privacy_Policy_Trackyo.pdf'
global.privacy_policy_viewer = `https://docs.google.com/viewer?url=${global.privacy_policy_url}&embedded=true`
global.terms_of_service_url = 'https://api.trackyo.in/docs/Terms_of_Service_Trackyo.pdf'
global.terms_of_service_viewer=`https://docs.google.com/viewer?url=${global.terms_of_service_url}&embedded=true`
global.billing_storage_url = 'http://43.205.171.148:8004/storage/public/'